import { useRouter as useNextRouter } from 'next/router';

export function useRouter() {
  return useNextRouter();
}


export default useRouter;
